import { merge } from 'lodash';
import { normalize, schema } from 'normalizr';
import { combineReducers } from 'redux';

// Define a marutis schema
const marutiSchema = new schema.Entity('marutis', {}, { idAttribute: 'redisId' });
const marutiListSchema = [marutiSchema];

const defaultMarutiParams = {
  marutiFetched: false,
  searchFetched: false,
  createTitle: 'Create New Maruti',
  createSubmitButtonText: 'Create Maruti',
  editTitle: 'Edit Maruti',
  editSubmitButtonText: 'Edit Maruti'
}

//normalized object
function byId(state = {}, action) {
  if (action.type === 'FETCHED_MARUTI_SYNC') {
    const normalizedMaruti = normalize(action.payload, marutiListSchema);
    return merge({}, normalizedMaruti.entities.marutis)
  }
  if (action.type === 'REPOST_REDISID_SYNC') {
    console.log('appied job', action.payload)
    return {
      ...state,
      [action.payload]: {
        ...state[action.payload],
        postStatus: 1

      }
    }
  }
  if (action.type === 'RESET_DATA') {
    return {}
  } else {
    return state
  }

}

//array of object
function collection(state = [], action) {
  if (action.type === 'FETCHED_MARUTI_SYNC') {
    return action.payload
  }
  if (action.type === 'RESET_DATA') {
    return []
  } else {
    return state
  }
}

function searchResults(state = {}, action) {
  if (action.type === 'STORE_SEARCH_MARUTI_RESULT_SYNC') {
    const normalizedMaruti = normalize(action.payload, marutiListSchema);
    return merge({}, normalizedMaruti.entities.marutis)
  } else {
    return state
  }
}

function filterResults(state = {}, action) {
  if (action.type === 'FILTER_ITEMS_SYNC') {
    const col = action.payload.col;
    return {
      ...state,
      [col]: action.payload
    }
  } else {
    return state
  }
}

function fetchedOldSyncStatus(state = "", action) {
  if (action.type === 'FETCHED_PULL_OLD_SYNC_STATUS_MARUTI') {
    // console.log(action.payload,'------acp')
    return action.payload
  }
  else {
    return state
  }
}



function params(state = defaultMarutiParams, action) {
  if (action.type === 'FETCHED_MARUTI_SYNC') {
    return {
      ...state,
      marutiFetched: true,
      isFetching: false
    }
  } if (action.type === 'SEARCH_MARUTI_SYNC') {
    return {
      ...state,
      searchFetched: false,
      isSearching: true,
    }
  }
  if (action.type === 'STORE_SEARCH_MARUTI_RESULT_SYNC') {
    return {
      ...state,
      searchFetched: true,
      isSearching: false,
    }
  } if (action.type === 'SET_MARUTI_FETCH_OFF') {
    return {
      ...state,
      isDelFetched: false
    }
  }
  if (action.type === 'RESET_DATA') {
    return defaultMarutiParams
  } else {
    return state
  }
}

function notificationsPopup(state = {}, action) {
  if (action.type === "SYNCED_UTD_MARUTI") {
    return {
      ...state,
      type: {
        status: action.payload.msg.toLowerCase() === "done" ? "success" : "error",
        msg: "Successfully Posted!",
      },
    };
  }
  if (action.type === "NOTIFICATION_DONE_ITEM_MARUTI") {
    return {
      ...state,
      type: {
        status: "",
        msg: "",
      },
    };
  } else {
    return state;
  }
}

const marutiSync = combineReducers({
  byId,
  collection,
  searchResults,
  params,
  filterResults,
  fetchedOldSyncStatus,
  notificationsPopup
});

export default marutiSync;

